import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputText } from 'primereact/inputtext';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { createApiKey } from '../../services/ApiKeysService';
import { CreateApiKeyRequest } from '../../models/ApiKeyResponse';

interface ApiKeyCreateProps {
  afterSave: () => void;
}

const ApiKeyCreate: React.FC<ApiKeyCreateProps> = ({ afterSave }) => {
  const { t } = useTranslation();
  const [apiError, setApiError] = useState<string | null>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const validityOptions = [
    { label: t('never'), value: undefined },
    { label: t('30Days'), value: 30 },
    { label: t('90Days'), value: 90 },
    { label: t('180Days'), value: 180 },
    { label: t('365Days'), value: 365 },
  ];

  const onSubmit = async (formData: any) => {
    try {
      setApiError(null);
      const request: CreateApiKeyRequest = { 
        validForDays: formData.validForDays ? parseInt(formData.validForDays) : undefined,
        description: formData.description || undefined
      };
      await createApiKey(request);
      afterSave();
    } catch (error: any) {
      console.error('Failed to create API key:', error);
      setApiError(error.response?.data?.error || t('createApiKeyError'));
    }
  };

  const clearApiError = () => {
    setApiError(null);
  };

  return (
    <div className="">
      <form onSubmit={handleSubmit(onSubmit)} className="form-box__form">
        <div className="form-box__row">
          <div className="form-box__label">{t('description')}:</div>
          <InputText
            onInput={clearApiError}
            {...register('description')}
            placeholder={t('enterDescription')}
            className={errors.description || apiError ? 'form-box__invalid' : ''}
          />
          {errors.description && <span>{errors.description.message as string}</span>}
        </div>
        
        <div className="form-box__row">
          <div className="form-box__label">{t('validityPeriod')}:</div>
          <Dropdown
            {...register('validForDays')}
            options={validityOptions}
            placeholder={t('selectValidityPeriod')}
            className="dropdown"
            optionLabel="label"
            optionValue="value"
          />
        </div>
        
        {apiError && (
          <div className="p-error">
            {apiError}
          </div>
        )}

        <Button className="btn btn--sm" label={t('create')} type="submit" />
      </form>
    </div>
  );
};

export default ApiKeyCreate;
